{
  "organization": {
    "seatOverrun": {
      "title": "Organisation verrouillée",
      "description": "Votre organisation compte plus d'utilisateurs que de sièges. Un responsable d'organisation ou un administrateur système doit résoudre ce problème avant que l'application puisse être utilisée.",
      "seatPool": "Pool de sièges",
      "resolverDescription": "Suspendez ou supprimez des utilisateurs jusqu'à ce que chaque pool de sièges respecte sa limite.",
      "stuckDescription": "Aucun siège du pool saturé ne peut être libéré depuis cette page. Contactez le support pour faire relever la limite de sièges.",
      "overBy": "{{over}} au-dessus de la limite",
      "loadError": "Les données de sièges n'ont pas pu être chargées."
    },
    "tabs": {
      "departments": "Départements",
      "functions": "Fonctions",
      "teams": "Équipes",
      "members": "Personnes",
      "systems": "Systèmes",
      "externalContacts": "Contacts externes",
      "artifacts": "Documents"
    },
    "organigram": {
      "title": "Organigramme",
      "description": "Organigramme interactif montrant la hiérarchie de vos départements",
      "empty": "Aucun département trouvé. Créez des départements pour construire votre organigramme.",
      "fitView": "Ajuster à la vue",
      "memberCount_one": "{{count}} personne",
      "memberCount_other": "{{count}} personnes",
      "manager": "Responsable",
      "notAssigned": "Non assigné",
      "level": "Niveau"
    },
    "systems": {
      "title": "Systèmes",
      "description": "Gérer tous les systèmes de votre organisation",
      "empty": "Aucun système trouvé",
      "search": "Rechercher des systèmes...",
      "softwareSystem": "Système logiciel",
      "category": "Catégorie",
      "url": "Lien vers le système",
      "create": "Créer un système",
      "editSystem": "Modifier le système",
      "createSystemDescription": "Ajouter un nouveau système logiciel à votre organisation",
      "editSystemDescription": "Mettre à jour les détails de ce système logiciel",
      "namePlaceholder": "Saisir le nom du système",
      "descriptionPlaceholder": "Saisir la description du système",
      "categoryPlaceholder": "Saisir la catégorie",
      "urlPlaceholder": "https://exemple.fr",
      "systemOwner": "Propriétaire du système",
      "systemOwnerPlaceholder": "Sélectionner le propriétaire du système...",
      "basicInformation": "Informations de base",
      "ownership": "Propriété",
      "systemDetails": "Détails du système",
      "licenceSeatsLabel": "Licences",
      "licenceSeatsPlaceholder": "ex. 50",
      "notFound": "Système non trouvé",
      "noDescription": "Aucune description disponible",
      "saveFailed": "Échec de l'enregistrement du système",
      "logoUploadFailed": "Le système a été enregistré, mais le téléversement du logo a échoué. Vous pourrez ajouter le logo plus tard en modifiant le système.",
      "stats": {
        "totalUsers": "Utilisateurs au total",
        "totalUsersDescription": "Utilisateurs impliqués avec ce système",
        "totalOrgFunctions": "Fonctions au total",
        "totalOrgFunctionsDescription": "Fonctions impliquées avec ce système",
        "totalRoles": "Total des postes",
        "totalRolesDescription": "Différents postes des utilisateurs",
        "totalProcesses": "Processus au total",
        "totalProcessesDescription": "Processus utilisant ce système",
        "capacityBinding": "Engagement de capacité",
        "capacityBindingNoData": "Aucune donnée de capacité disponible",
        "perMonth": "par mois",
        "perYear": "par an",
        "clickToToggle": "cliquer pour basculer",
        "costCalculation": "Calcul des coûts",
        "costPerMonth": "Coût par mois",
        "costPerYear": "Coût par an",
        "billingRateInfo": "Basé sur un taux horaire de {{rate}}/heure",
        "stepsWithData": "{{count}} sur {{total}} étapes ont des données de capacité",
        "licenceSeats": "Licences",
        "licenceSeatsUsed": "Licences utilisées"
      },
      "capacityCell": {
        "monthSuffix": "/mois",
        "yearSuffix": "/an"
      },
      "processesImpacted": {
        "title": "Processus impactés",
        "processName": "Nom du processus",
        "stepsInvolved": "Étapes impliquées",
        "avgRating": "Évaluation moy.",
        "mediaBreaks": "Ruptures média",
        "capacity": "Capacité",
        "action": "Action",
        "viewSteps": "Voir les étapes",
        "noProcesses": "Aucun processus n'interagit encore avec ce système",
        "stepExplorer": "Explorateur d'étapes"
      },
      "systemUsers": {
        "title": "Utilisateurs du système",
        "user": "Utilisateur",
        "role": "Poste",
        "involvedProcesses": "Processus impliqués",
        "noUsers": "Aucun utilisateur n'interagit encore avec ce système",
        "searchPlaceholder": "Rechercher des utilisateurs...",
        "filterByRole": "Filtrer par poste",
        "allRoles": "Tous les postes",
        "involvementType": {
          "owner": "Propriétaire",
          "helper": "Assistant",
          "whoElseDoesThis": "Fait aussi cela"
        }
      },
      "topRoles": {
        "title": "Postes principaux",
        "noRoles": "Aucun poste trouvé pour ce système",
        "allRolesTitle": "Tous les postes"
      },
      "departments": {
        "title": "Départements",
        "noDepartments": "Aucun département trouvé pour ce système",
        "membersSuffix": "personnes",
        "allDepartmentsTitle": "Tous les départements"
      },
      "topOrgFunctions": {
        "title": "Fonctions principales",
        "noOrgFunctions": "Aucune fonction trouvée pour ce système",
        "allOrgFunctionsTitle": "Toutes les fonctions"
      },
      "criticalDependencies": {
        "title": "Avertissement de dépendance critique",
        "description": "Ces étapes de processus dépendent d'une seule personne sans remplaçant. Si cette personne n'est pas disponible, l'étape ne peut pas être exécutée.",
        "processStep": "Processus / Étape",
        "assignedTo": "Assigné à",
        "role": "Poste",
        "showAll": "Afficher les {{count}}",
        "showLess": "Afficher moins"
      },
      "interactions": {
        "title": "Interactions système",
        "upstream": "AMONT (ENTRÉE)",
        "downstream": "AVAL (SORTIE)",
        "noUpstream": "Aucun système en amont",
        "noDownstream": "Aucun système en aval",
        "view3d": "3D",
        "viewList": "Liste",
        "viewFlow": "Flux",
        "fullscreen": "Plein écran",
        "exitFullscreen": "Quitter le plein écran",
        "resetView": "Réinitialiser la vue",
        "pause": "Suspendre la rotation",
        "play": "Reprendre la rotation",
        "linkInteractions": "{{count}} interaction",
        "linkInteractions_other": "{{count}} interactions"
      },
      "mediaBreakMap": {
        "title": "Carte des ruptures média",
        "breaksBefore": "Ruptures avant",
        "breaksAfter": "Ruptures après",
        "mostFrequent": "Ruptures les plus fréquentes",
        "foundInProcesses": "Trouvé dans {{count}} processus"
      },
      "deletePhrase": "ce système"
    },
    "departments": {
      "title": "Départements",
      "description": "Aperçu de tous les départements de votre organisation",
      "empty": "Aucun département trouvé",
      "search": "Rechercher des départements...",
      "members": "Personnes",
      "noMembersFound": "Aucune personne trouvée",
      "searchMembers": "Rechercher des personnes...",
      "teams": "Équipes",
      "noTeamsFound": "Aucune équipe dans ce département",
      "searchTeams": "Rechercher des équipes...",
      "headOfDepartment": "Chef de département",
      "abbreviation": "Abréviation",
      "create": "Créer un département",
      "editDepartment": "Modifier le département",
      "createDepartmentDescription": "Ajouter un nouveau département à votre organisation",
      "editDepartmentDescription": "Mettre à jour les détails de ce département",
      "namePlaceholder": "Saisir le nom du département",
      "descriptionPlaceholder": "Saisir la description du département",
      "parentDepartment": "Département parent",
      "selectParent": "Sélectionner le département parent",
      "manager": "Responsable",
      "selectManager": "Sélectionner le responsable",
      "relationships": "Affectation",
      "notFound": "Département non trouvé",
      "detailDescription": "Voir et gérer les détails du département",
      "details": "Détails du département",
      "bulkUpload": "Import en masse",
      "bulkUploadPage": {
        "title": "Import en masse de départements",
        "description": "Importer plusieurs départements depuis Excel avec des relations hiérarchiques",
        "uploadFromExcel": "Importer depuis Excel",
        "downloadTemplate": "Télécharger le modèle",
        "draftDepartments": "Départements brouillons",
        "createAll": "Tout créer",
        "cancel": "Annuler",
        "fixErrorsWarning": "Veuillez corriger toutes les erreurs avant de soumettre",
        "successCreated": "{{count}} départements créés avec succès",
        "validationError": "Échec de la validation. Veuillez corriger les erreurs et réessayer",
        "circularDependency": "Dépendance circulaire détectée dans la hiérarchie des départements",
        "parentInBatch": "Le parent sera créé dans ce lot",
        "parentInDatabase": "Le parent existe dans la base de données",
        "parentNotFound": "Département parent non trouvé",
        "creationOrder": "Ordre de création",
        "rowNumber": "Ligne n°",
        "noDrafts": "Aucun département brouillon. Importez depuis Excel ou ajoutez manuellement.",
        "uploadSuccess": "{{count}} départements analysés avec succès",
        "uploadPartial": "{{valid}} valides et {{invalid}} invalides analysés",
        "uploadAllInvalid": "Les {{count}} départements ont des erreurs",
        "fileInvalidFormat": "Format de fichier invalide. Veuillez importer un fichier Excel (.xlsx ou .xls)",
        "uploadError": "Erreur lors de l'import du fichier Excel",
        "addManually": "Ajouter manuellement",
        "addManuallyDescription": "Ajouter un seul département au lot",
        "editDraft": "Modifier le département brouillon",
        "editDraftDescription": "Modifier les détails du département",
        "confirmDeleteDraft": "Supprimer ce département de l'import ?",
        "parentComboPlaceholder": "Sélectionner un existant ou saisir l'abréviation du lot",
        "managerEmailPlaceholder": "responsable@exemple.fr",
        "validationErrors": "Erreurs de validation",
        "instruction1": "Champs requis : Nom et Abréviation",
        "instruction2": "L'abréviation du parent peut référencer des départements existants ou des départements de cet import",
        "instruction3": "Évitez les dépendances circulaires (A → B → A)",
        "instruction4": "L'e-mail du responsable doit correspondre à un utilisateur existant dans le système",
        "circularDependencyReview": "Veuillez vérifier les relations parent-enfant pour vous assurer qu'il n'y a pas de dépendances circulaires.",
        "useBatchAbbreviation": "Utiliser \"{{abbreviation}}\" comme abréviation du lot",
        "existingDepartments": "Départements existants (Base de données)",
        "batchDepartments": "Départements du lot (Import actuel)"
      },
      "deletePhrase": "ce département"
    },
    "orgFunctions": {
      "details": "Détails de la fonction",
      "namePlaceholder": "Saisir le nom de la fonction",
      "emailPlaceholder": "Saisir l'adresse e-mail",
      "descriptionPlaceholder": "Saisir une description",
      "selectDepartment": "Sélectionner un département",
      "noDepartment": "Aucun département",
      "selectLead": "Sélectionner un responsable de la fonction",
      "selectTeamLead": "Sélectionner un responsable d'équipe",
      "noLead": "Aucun responsable de la fonction",
      "noTeamLead": "Aucun responsable d'équipe",
      "email": "Boîte aux lettres partagée",
      "lead": "Responsable de la fonction",
      "teamLead": "Responsable d'équipe",
      "department": "Département",
      "kind": {
        "label": "Type",
        "team": "Équipe",
        "role": "Fonction"
      },
      "members": {
        "title": "Personnes",
        "empty": "Aucune personne trouvée",
        "search": "Rechercher des personnes...",
        "leadBadge": "Responsable de fonction",
        "label": "Personnes (fonction supplémentaire)",
        "hint": "Les personnes sélectionnées détiennent cette fonction comme fonction supplémentaire en plus de leur poste.",
        "hintMainRoleLocked": "Les personnes dont le poste correspond à cette fonction sont présélectionnées et verrouillées.",
        "available": "Personnes disponibles",
        "selected": "Personnes sélectionnées",
        "filterByDepartment": "Filtrer par département",
        "loadError": "Les personnes détenant cette fonction n'ont pas pu être chargées. Fermez la fenêtre et réessayez pour les modifier.",
        "mainRoleLocked": "Cette fonction est attribuée en tant que poste et ne peut pas être retirée ici — modifiez plutôt le poste de la personne."
      },
      "memberCount": "Personnes",
      "deletePhrase": {
        "team": "cette équipe",
        "role": "cette fonction"
      }
    },
    "functions": {
      "title": "Fonctions",
      "description": "Gérer toutes les fonctions de votre organisation",
      "empty": "Aucune fonction trouvée",
      "search": "Rechercher des fonctions...",
      "create": "Créer une fonction",
      "createDescription": "Ajouter une nouvelle fonction à votre organisation",
      "edit": "Modifier la fonction",
      "editDescription": "Mettre à jour les détails de cette fonction",
      "detailDescription": "Afficher les détails de la fonction",
      "notFound": "Fonction non trouvée"
    },
    "teams": {
      "title": "Équipes",
      "description": "Gérer toutes les équipes de votre organisation",
      "empty": "Aucune équipe trouvée",
      "search": "Rechercher des équipes...",
      "create": "Créer une équipe",
      "createDescription": "Ajouter une nouvelle équipe à votre organisation",
      "edit": "Modifier l'équipe",
      "editDescription": "Mettre à jour les détails de cette équipe",
      "detailDescription": "Afficher les détails de l'équipe",
      "notFound": "Équipe non trouvée"
    },
    "myOrgFunctions": {
      "title": "Mes fonctions",
      "description": "Découvrez dans quelles fonctions et équipes vous intervenez au sein de votre entreprise.",
      "empty": "Aucune fonction ne vous a encore été attribuée."
    },
    "members": {
      "title": "Personnes",
      "description": "Aperçu de tous les collaborateurs de votre organisation",
      "empty": "Aucune personne trouvée",
      "search": "Rechercher des personnes...",
      "createMember": "Créer une personne",
      "inviteAllInactive": "Inviter tous les utilisateurs inactifs",
      "inviteAllInactiveConfirm": "Envoyer des e-mails d'invitation à {{count}} utilisateur(s) inactif(s) ?",
      "inviteAllInactiveSuccess": "{{count}} invitation(s) envoyée(s)",
      "inviteAllInactiveSkipped": "{{count}} utilisateur(s) ignoré(s)",
      "editMember": "Modifier la personne",
      "createMemberDescription": "Ajouter une nouvelle personne à votre organisation",
      "editMemberDescription": "Mettre à jour les détails de cette personne",
      "notFound": "Personne non trouvée",
      "detailDescription": "Voir et gérer les détails de la personne",
      "details": "Détails de la personne",
      "firstName": "Prénom",
      "lastName": "Nom",
      "firstNamePlaceholder": "Saisir le prénom",
      "lastNamePlaceholder": "Saisir le nom",
      "emailPlaceholder": "Saisir l'adresse e-mail",
      "emailChangeWarning": "Cela modifie l'adresse e-mail avec laquelle cette personne se connecte.",
      "relationships": "Affectation",
      "selectDepartment": "Sélectionner le département",
      "mainRole": "Poste",
      "selectMainRole": "Sélectionner le poste",
      "secondaryRoles": "Fonctions supplémentaires",
      "selectSecondaryRoles": "Sélectionner les fonctions supplémentaires",
      "location": "Site",
      "selectLocation": "Sélectionner le site",
      "accessPermissions": "Accès et permissions",
      "selectUserTypes": "Sélectionner les types d'utilisateur",
      "selectClassification": "Sélectionner la classification",
      "externalOrganization": "Organisation externe",
      "externalOrgPlaceholder": "Saisir le nom de l'organisation externe",
      "sendInvitation": "Envoyer l'e-mail d'invitation",
      "sendInvitationHelper": "La personne sera informée par e-mail.",
      "statusActions": "Actions",
      "sendInvitationAction": "Envoyer l'invitation",
      "resendInvitationAction": "Renvoyer l'invitation",
      "userInactive": "Cet utilisateur n'a pas encore été invité",
      "userPendingInvitation": "Cet utilisateur attend l'activation de son compte. Vous pouvez renvoyer l'invitation si nécessaire.",
      "userSuspended": "Cet utilisateur est actuellement suspendu",
      "suspendUser": "Suspendre l'utilisateur",
      "unsuspendUser": "Réactiver l'utilisateur",
      "sendInvitationSuccess": "Invitation envoyée",
      "suspendSuccess": "Utilisateur suspendu",
      "unsuspendSuccess": "Utilisateur réactivé",
      "suspendUserPrompt": "Vous pouvez suspendre cet utilisateur pour révoquer temporairement son accès",
      "resetSignInAction": "Réinitialiser les identifiants de connexion",
      "resetSignInDescription": "Les méthodes de connexion actuelles de {{name}} ({{email}}) — mot de passe, clés d'accès (passkeys), applications d'authentification — cessent de fonctionner et cette personne est déconnectée de tous les espaces de travail. Elle reçoit un e-mail pour configurer à nouveau ses identifiants de connexion et ne peut pas se connecter avant de l'avoir fait.",
      "resetSignInConfirmInstruction": "Saisissez <strong /> pour confirmer la réinitialisation.",
      "resetSignInConfirmLabel": "Nom de la personne",
      "resetSignInSuccess": "Identifiants de connexion réinitialisés. Un e-mail pour les configurer à nouveau a été envoyé.",
      "homeOrgDeletedBadge": "Organisation d'origine supprimée",
      "homeOrgDeletedTooltip": "L'organisation d'origine de ce membre a été supprimée — la connexion est (ou sera) bloquée. Un administrateur de la plateforme peut attribuer une nouvelle organisation d'origine pour rétablir l'accès.",
      "deletePhrase": "cette personne"
    },
    "contacts": {
      "title": "Contacts externes",
      "description": "Aperçu de tous les contacts externes",
      "empty": "Aucun contact externe trouvé",
      "search": "Rechercher des contacts externes...",
      "create": "Créer un contact",
      "notFound": "Contact non trouvé",
      "detailDescription": "Voir et gérer les détails du contact",
      "details": "Détails du contact",
      "deletePhrase": "ce contact"
    },
    "externalContacts": {
      "createContact": "Créer un contact",
      "editContact": "Modifier le contact",
      "createContactDescription": "Ajouter un nouveau contact externe",
      "editContactDescription": "Mettre à jour les détails de ce contact",
      "nameLabel": "Nom du contact",
      "typeSectionLabel": "Type de contact",
      "typeLabel": "Type de contact (sélectionner dans la liste ou créer)",
      "namePlaceholder": "Saisir le nom du contact (p. ex. Banque Exemple, client privé)",
      "typePlaceholder": "Sélectionner le type de contact",
      "descriptionPlaceholder": "Saisir la description",
      "types": {
        "customer": "Client",
        "partner": "Partenaire",
        "vendor": "Fournisseur",
        "other": "Autre"
      }
    },
    "artifacts": {
      "title": "Documents",
      "description": "Aperçu de tous les documents utilisés dans les processus de votre organisation",
      "empty": "Aucun document trouvé",
      "search": "Rechercher des documents...",
      "size": "Taille",
      "createdBy": "Créé par",
      "type": "Format de fichier",
      "fileUrl": "Lien vers le document",
      "create": "Créer un document",
      "editArtifact": "Modifier le document",
      "createArtifactDescription": "Ajouter un nouveau document",
      "editArtifactDescription": "Mettre à jour les détails de ce document",
      "namePlaceholder": "p. ex. Liste de contrôle de classification client",
      "descriptionPlaceholder": "p. ex. Liste de contrôle pour la classification des clients.",
      "typePlaceholder": "p. ex. PDF, Excel, Word",
      "fileUrlPlaceholder": "https://exemple.fr/fichier.pdf",
      "notFound": "Document non trouvé",
      "detailDescription": "Voir et gérer les détails du document",
      "details": "Détails du document",
      "addNew": "Ajouter nouveau",
      "types": {
        "document": "Document",
        "image": "Image",
        "video": "Vidéo",
        "other": "Autre"
      },
      "deletePhrase": "ce document"
    }
  },
  "organizations": {
    "Level": "Niveau",
    "Abbreviation": "Abréviation",
    "Description": "Description",
    "ParentDepartment": "Département parent"
  },
  "OrgSettingPage": {
    "Settings": "Paramètres",
    "editKeyDetails": "Configurez les paramètres de votre organisation",
    "OrganizationLogo": "Logo de l'organisation",
    "Upload": "Télécharger",
    "Organizationname": "Nom de l'organisation",
    "Language": "Langue",
    "RecordingTime": "Temps d'enregistrement par défaut (heures)",
    "recordingTimeHint": "Combien de temps doit-il s'écouler avant qu'un enregistrement d'étape de processus assigné soit considéré comme « en retard » ?",
    "reviewTimeFrame": "Délai standard de révision des processus",
    "reviewTimeFrameHint": "Après combien de jours souhaitez-vous réenregistrer le même processus pour voir s'il a changé ?",
    "RatingAndComment": "Évaluation et commentaire",
    "FrequencyMeasurement": "Mesure de fréquence",
    "DurationMeasurement": "Mesure de durée",
    "VariantCheck": "Vérification des variantes",
    "SettingSaved": "Paramètre enregistré avec succès.",
    "ExportData": "Exporter les données",
    "ExportDataSuccess": "Données exportées avec succès !",
    "days": "Jours",
    "hours": "Heures",
    "logoUploadHint": "SVG, PNG, JPG ou GIF (max. 800x800px) ou 3 Mo",
    "fieldRequired": "Le champ est requis.",
    "noCommaAllowed": "La valeur ne doit pas contenir de virgule.",
    "mustBePositive": "La valeur doit être supérieure à 0.",
    "internalBillingRate": "Taux de facturation interne",
    "internalBillingRateUnit": "€/h",
    "languageEnglish": "English",
    "languageGerman": "Deutsch",
    "languageHungarian": "Magyar",
    "languageFrench": "Français",
    "organizationProfileTitle": "Profil de l'organisation",
    "organizationProfileDesc": "Gérer le logo et l'identité de votre organisation",
    "preferencesTitle": "Préférences",
    "preferencesDesc": "Définissez les valeurs par défaut de votre organisation.",
    "surveySettingsTitle": "Paramètres d'enquête",
    "surveySettingsDesc": "Contrôlez quelles enquêtes sont affichées aux personnes après l'enregistrement et quelles valeurs doivent être collectées",
    "capacityPriority": "Source de capacité",
    "capacityPrioritySurveyFirst": "Relevé en premier",
    "capacityPrioritySurveyFirstDesc": "La valeur relevée ; à défaut, la valeur saisie manuellement est retenue.",
    "capacityPriorityManualFirst": "Manuel en premier",
    "capacityPriorityManualFirstDesc": "La valeur saisie manuellement ; à défaut, la valeur relevée est retenue.",
    "capacityPrioritySurveyOnly": "Relevé uniquement",
    "capacityPrioritySurveyOnlyDesc": "Seules les valeurs relevées sont retenues. Les valeurs manuelles restent enregistrées.",
    "capacityPriorityManualOnly": "Manuel uniquement",
    "capacityPriorityManualOnlyDesc": "Seules les valeurs manuelles sont retenues. Les valeurs relevées restent enregistrées.",
    "privacyMode": "Visibilité des processus",
    "privacyNeedToKnow": "Besoin de savoir",
    "privacyNeedToKnowDesc": "Les utilisateurs ne voient que les processus auxquels ils sont affectés",
    "privacyFullTransparency": "Transparence totale",
    "privacyFullTransparencyDesc": "Tous les utilisateurs peuvent voir chaque processus",
    "ai": {
      "title": "Fonctionnalités IA",
      "description": "Activer et configurer les fonctionnalités alimentées par l'IA pour votre organisation",
      "bliksyEnableLabel": "Activer Bliksy",
      "bliksyEnableDescription": "Permettre aux utilisateurs d'utiliser l'assistant IA Bliksy pendant les enregistrements",
      "stepNameGenerationLabel": "Générer automatiquement les noms d'étapes",
      "stepNameGenerationDescription": "Générer automatiquement les noms et descriptions des étapes de processus enregistrées à l'aide de l'IA",
      "appsTitle": "Fonctionnalités IA des applications",
      "appsDescription": "Activer ou désactiver individuellement les fonctionnalités IA des applications de votre organisation. Une application masque une fonctionnalité désactivée."
    }
  },
  "department": {
    "tabs": {
      "members": "Personnes",
      "teams": "Équipes"
    },
    "selector": {
      "placeholder": "Sélectionner un département..."
    },
    "members": {
      "title": "Personnes dans mon département",
      "description": "Gérer les personnes du département {{department}}",
      "descriptionDefault": "Gérer les personnes de votre département",
      "empty": "Aucune personne trouvée dans votre département",
      "search": "Rechercher des personnes...",
      "createMember": "Ajouter une personne"
    },
    "teams": {
      "title": "Équipes de mon département",
      "description": "Gérer les équipes du département {{department}}",
      "descriptionDefault": "Gérer les équipes de votre département",
      "empty": "Vos départements n'ont pas d'équipes fixes",
      "search": "Rechercher des équipes...",
      "createTeam": "Ajouter une équipe",
      "noAccess": "Vous ne gérez aucun département."
    }
  },
  "organizationSettings": {
    "userManagement": {
      "title": "Gestion des utilisateurs",
      "description": "Gérer l'accès, les types et les permissions des utilisateurs de votre organisation."
    },
    "softwareList": {
      "title": "Liste des logiciels",
      "description": "Gérer et configurer les systèmes logiciels utilisés par votre organisation.",
      "create": "Créer un système",
      "empty": "Aucun système trouvé"
    }
  }
}
